'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.friendbuy = undefined;

var _sagaTools = require('@classpass/saga-tools');

var _dal = require('@classpass/dal');

var friendbuy = exports.friendbuy = (0, _sagaTools.makeEntityScaffold)('SAGA.API.FRIENDBUY', function (client, referralCode) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.friendbuy.getReferral(referralCode, options).catch(function (err) {
    // 404s just mean that code is invalid
    if (err instanceof _dal.DALNotFoundError) {
      return false;
    }
    throw err;
  });
}, { defaultKey: 1 });